<template>
    <div ref="errorModal" class="modal row" v-if="!toast">
        <div class="col s12 pa-1"><h4 class="ma-0">{{title}}</h4></div>
        <div class="divider col s12 pa-0" />
        <div class="col s12 pa-1">
            <p v-if="icon" class="center-align">
                <i class="material-icons large" :class="iconColor">{{icon}}</i>
            </p>
            <p v-for="(item, index) in detail && detail.split(';')" class="center-align" :key="index">{{item}}</p>
            <p v-if="detailHtml" v-html="detailHtml"></p>
        </div>
        <div class="divider col s12 pa-0" />
        <div class="col s12 pa-1">
            <a href="#!" @click.prevent="fechar" class="modal-action waves-effect waves-green btn-flat right">Fechar</a>
        </div>
    </div>
</template>
<script>
import StHelper from '../../helpers/StHelper';
export default {
    name:'error-dialog',
    props: {
        errorObject:null,
        toast: {type: Boolean, required: false, default: false},
    },
    watch:{
        errorObject:function(newValue) {
            console.error('Error Dialog: ', newValue);
            try {
                if (typeof(newValue) == 'array'){
                    this.title ='Problemas Encontrados';
                    this.detail = newValue.join('<br>');
                } else if(typeof(newValue) == 'string'){
                    this.title ='Erro';
                    this.detail = newValue;
                } else if(typeof(newValue) == 'error'){
                    this.title ='Erro';
                    this.detail = newValue.toString();
                } else if (newValue && [500, 412].includes(newValue.status)) {
                    this.title = 'Atenção!';
                    if(newValue.body && newValue.body.detail) {
                        this.detailHtml = newValue.body.detail;
                    } else {
                        this.detailHtml = newValue.bodyText;
                    }
                } else if (newValue.title && newValue.detail){
                    this.title = newValue.title;
                    this.detail = newValue.detail;
                    if (newValue.icon)this.icon = newValue.icon;
                    if (newValue.iconColor)this.icon = newValue.iconColor;
                } else if (newValue.body && newValue.body.title && newValue.body.detail){
                    this.title = newValue.body.title;
                    this.detail = newValue.body.detail;
                    if (newValue.icon)this.icon = newValue.icon;
                    if (newValue.iconColor)this.icon = newValue.iconColor;
                } else if (newValue.bodyText){
                    let obj = JSON.parse(newValue.bodyText);

                    this.title = obj.title;
                    if (obj.detail) this.detail = obj.detail;
                    if (obj.description) this.detail = obj.description;
                } else if (this.isFunction(newValue.json) ) {
                    newValue.json()
                        .then((obj)=>{
                            if (obj) this.interpretar(obj);
                            else this.interpretar(newValue);
                        })
                        .catch((err) => {
                            if (obj) this.interpretar(obj);
                            else this.interpretar(newValue);
                        })
                } else {
                    this.title ='Erro Desconhecido';
                    this.detail = `Se o erro persistir, entre em contato com administrador do sistema.  "${newValue.message}"`;
                }
                if(this.toast) StHelper.toastAlertaNegative(this.toastMsg(), 8000);
            } catch(e) {
                if (!newValue) return;
                this.detail = e.toString();
                if(this.toast) StHelper.toastAlertaNegative(this.toastMsg(), 8000);
            }
            try {
                $(this.$refs.errorModal).modal('open');
            } catch(e) {
                console.error(e);
            }
        }
    },
    methods:{
        fechar() {
            this.$emit('onClose');
            $(this.$refs.errorModal).modal('close');
        },
        interpretar(obj) {
            if (obj && obj.stackTrace) {
                this.title = obj.title;
                this.detail = obj.stackTrace;
            } else if(obj && obj.description) {
                this.title = obj.title;
                this.detail = obj.description;
            } else if(obj && obj.title && obj.detail) {
                this.title = obj.title;
                this.detail = obj.detail;
            } else if (obj) {
                this.title = 'Erro';
                this.detail = obj.title;
            } else if(newValue.title && newValue.detail){
                this.title = newValue.title;
                this.detail = newValue.detail;
            } if (newValue.body.title && newValue.body.detail){
                this.title = newValue.body.title;
                this.detail = newValue.body.detail;
            } if (newValue.bodyText.title && newValue.bodyText.detail){
                this.title = newValue.bodyText.title;
                this.detail = newValue.bodyText.detail;
            } else if (newValue.body) {
                this.title = 'Erro';
                this.detail = newValue.body;
            } else {
                this.title = 'Erro';
                this.detail = obj;
            }
        },
        isFunction(functionToCheck) {
            let getType = {};
            return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
        },
        toastMsg() {
            if(!this.title && !this.detail && !this.detailHtml) return;
            const iconHtml = !!this.icon && `<i class="material-icons large" :class="${this.iconColor}">${this.icon}</i> `
            return `${iconHtml ? iconHtml : ''} </b>${this.title}</b><br> ${this.detail || this.detailHtml}`;
        },
    },
    mounted(){
        $(this.$refs.errorModal).modal({
            complete: ()=> {
                this.title = null;
                this.detail = null;
                this.detailHtml = null;
                this.icon = null;
                this.iconColor = null;
                this.$emit('onClose');
            }
        });
    },
    data() {
        return {
            title:'',
            detail:'',
            detailHtml: null,
            icon:null,
            iconColor:'deep-orange-text'
        }
    }
}

</script>




// WEBPACK FOOTER //
// ErrorDialog.vue?85fc7db4